var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconDonations128(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_17288)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2276 79.8322C34.2276 79.8322 57.1819 88.7369 69.5785 88.7369C81.9751 88.7369 112 69.1466 112 69.1466C112 69.1466 111.184 58.4609 101.394 58.4609C98.9469 58.4609 83.7188 62.0228 83.7188 62.0228C83.7188 62.0228 83.9908 54.899 76.6487 54.899C69.3066 54.899 67.811 54.899 67.811 54.899C67.811 54.899 64.9879 44.1903 53.6706 45.9943C53.6706 45.9943 34.9083 49.846 36.2101 49.846C33.7627 49.846 34.2276 54.9565 34.2276 54.9565V79.8322Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.724 62.8945C83.724 62.8945 83.4693 71.0525 78.4166 71.0525C73.364 71.0525 58.9473 71.0525 58.9473 71.0525",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2105 43.2632H16V86.2105H36.2105V43.2632Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_17288"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconDonations128);
export default __webpack_public_path__ + "static/media/pictogramBeaconDonations128.ee4b862ec95aa9c74eb5ffa351ae0e59.svg";
export { ForwardRef as ReactComponent };